export default __webpack_public_path__ + "static/media/work-process.25e3ea71.png";